import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { LottieControl } from 'Organisms/LottieControl';
import { useLottieLoadingContext } from 'Organisms/LottieControl/LottieLoadingLayout';
import useMobileLayout from 'Hooks/useMobileLayout';

export const TransferLottieVertical = ({ resource }) => {
  const { setIsContentShowing } = useLottieLoadingContext();
  const isMobile = useMobileLayout();
  React.useEffect(() => {
    setIsContentShowing(false);
  }, []);

  return (
    <>
      {resource.withRelationship(fr.relationships.transferLottieVertical.name,
        (rel) => (
          <LottieControl
            src={rel.link('related').url()}
            onLoadSuccess={() => setIsContentShowing(true)}
            onLoadError={() => setIsContentShowing(true)}
            height={'auto'}
            width={isMobile ? '165px' : '100%'}
          />
        ),
        () => null)}
    </>
  );
};

TransferLottieVertical.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
